import React, { useEffect, useRef } from 'react';
import CompanyInfo from '../../components/CompanyInfo';
const RealEstateIndustry = () => {
  const canvasRef = useRef(null);
      const mousePosRef = useRef(null);
      const pointsRef = useRef([]);
      const animationRef = useRef(null);
    
      const maxDist = 200;
      const colour = "#FFFFFF";
    
      useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
    
        // Point constructor
        class Point {
          constructor() {
            this.x = (Math.random() * (canvas.width + maxDist)) - (maxDist / 2);
            this.y = (Math.random() * (canvas.height + maxDist)) - (maxDist / 2);
            this.vx = (Math.random() * 2) - 1;
            this.vy = (Math.random() * 2) - 1;
            this.dia = Math.random() * 3 + 1;
          }
        }
    
        // Generate points
        const generatePoints = (amount) => {
          pointsRef.current = [];
          for (let i = 0; i < amount; i++) {
            pointsRef.current.push(new Point());
          }
        };
    
        // Draw function
        const draw = (obj) => {
          ctx.beginPath();
          ctx.fillStyle = colour;
          if (obj.dia) {
            ctx.arc(obj.x, obj.y, obj.dia, 0, 2 * Math.PI);
          } else {
            ctx.arc(obj.x, obj.y, 2, 0, 2 * Math.PI);
          }
          ctx.closePath();
          ctx.fill();
        };
    
        // Update function
        const update = (obj) => {
          obj.x += obj.vx;
          obj.y += obj.vy;
          if (obj.x > canvas.width + (maxDist / 2)) {
            obj.x = -(maxDist / 2);
          } else if (obj.x < -(maxDist / 2)) {
            obj.x = canvas.width + (maxDist / 2);
          }
          if (obj.y > canvas.height + (maxDist / 2)) {
            obj.y = -(maxDist / 2);
          } else if (obj.y < -(maxDist / 2)) {
            obj.y = canvas.height + (maxDist / 2);
          }
        };
    
        // Collision detection and line drawing
        const collision = (obj, dist) => {
          let temp;
          for (let i = 0; i < pointsRef.current.length; i++) {
            if (obj !== pointsRef.current[i]) {
              temp = Math.sqrt(
                Math.pow((obj.x - pointsRef.current[i].x), 2) + 
                Math.pow((obj.y - pointsRef.current[i].y), 2)
              );
              if (temp < dist) {
                ctx.beginPath();
                ctx.moveTo(obj.x, obj.y);
                ctx.strokeStyle = `rgba(255,255,255,${0.8 * Math.pow((dist - temp) / dist, 5)})`;
                ctx.moveTo(obj.x, obj.y);
                ctx.lineTo(pointsRef.current[i].x, pointsRef.current[i].y);
                ctx.closePath();
                ctx.stroke();
              }
            }
          }
        };
    
        // Main animation loop
        const pointFun = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          if (mousePosRef.current) {
            collision(mousePosRef.current, maxDist * 2);
            draw(mousePosRef.current);
          }
          for (let i = 0; i < pointsRef.current.length; i++) {
            collision(pointsRef.current[i], maxDist);
            draw(pointsRef.current[i]);
            update(pointsRef.current[i]);
          }
        };
    
        // Resize canvas
        const resizeCanvas = () => {
          canvas.width = document.documentElement.clientWidth;
          canvas.height = window.innerHeight;
          generatePoints(170);
          pointFun();
        };
    
        // Mouse move handler
        const handleMouseMove = (evt) => {
          const rect = canvas.getBoundingClientRect();
          mousePosRef.current = {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
          };
        };
    
        // Initialize
        resizeCanvas();
        pointFun();
    
        // Start animation
        const interval = setInterval(pointFun, 16);
        animationRef.current = interval;
    
        // Event listeners
        window.addEventListener('resize', resizeCanvas);
        canvas.addEventListener('mousemove', handleMouseMove);
    
        // Cleanup
        return () => {
          clearInterval(interval);
          window.removeEventListener('resize', resizeCanvas);
          canvas.removeEventListener('mousemove', handleMouseMove);
        };
      }, []);
    
      return (
        <div style={{ 
          overflow: 'hidden',
          width: '100%',
          maxWidth: '100vw',
          position: 'relative',
             paddingTop: '130px'
        }}>
          <div style={{ 
            margin: 0, 
            padding: 0, 
            overflow: 'hidden',
            width: '100%',
            height: '60vh',
            position: 'relative'
          }}>
            <canvas
              ref={canvasRef}
              id="canvas"
              style={{
                overflow: 'hidden',
                cursor: 'none',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(to bottom, #306873, #52A7B0)'
              }}
            />
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              zIndex: 1
            }}>
              <h2 style={{
                color: '#ffffff',
                fontSize: '3rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                maxWidth: '800px',
                margin: '0 auto'
              }}>
                Real Estate Staffing Solutions
              </h2>
              <p style={{
                color: '#ffffff',
                fontSize: '1.25rem',
                marginTop: '1rem',
                textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                maxWidth: '600px',
                margin: '1rem auto 0'
              }}>
                Empower Your Real Estate Business with Remote Experts from <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span>
              </p>
            </div>
          </div>
          
     
  <section className="section_space bg-white">
          <div className="container">
            {/* Service Description */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="heading_block">
                  <h2 className="heading_text mb-4">Remote Staffing for Real Estate Success</h2>
                  <p className="heading_description mb-4">
                    <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> provides real estate agencies, brokers, and property managers with skilled remote professionals to streamline operations, manage listings, and enhance client engagement. Our flexible staffing solutions help you scale your business and focus on closing more deals.
                  </p>
                  <p className="heading_description mb-4">
                    From virtual assistants and transaction coordinators to marketing specialists and customer support, our vetted team handles the details so you can focus on growing your real estate portfolio. Let us help you deliver exceptional service and results.
                  </p>
                  <div className="row mt-5">
                    <div className="col-md-6">
                      <div className="iconbox_block layout_icon_left mb-4">
                        <div className="iconbox_content">
                          <h4 className="iconbox_title">Listing Management</h4>
                          <p>Accurate and timely updates to property listings, photos, and descriptions across all platforms.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="iconbox_block layout_icon_left mb-4">
                        <div className="iconbox_content">
                          <h4 className="iconbox_title">Lead Generation</h4>
                          <p>Proactive outreach and follow-up to nurture leads and schedule showings, helping you fill your pipeline.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="iconbox_block layout_icon_left mb-4">
                        <div className="iconbox_content">
                          <h4 className="iconbox_title">Transaction Coordination</h4>
                          <p>Seamless support for contracts, paperwork, and compliance to ensure smooth closings.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="iconbox_block layout_icon_left mb-4">
                        <div className="iconbox_content">
                          <h4 className="iconbox_title">Client Communication</h4>
                          <p>Prompt responses and ongoing updates to keep buyers, sellers, and renters informed at every step.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <p className="heading_description">
                      We support real estate professionals in residential, commercial, and property management sectors. Our remote staffing solutions are tailored to your business goals, ensuring you get the right talent for every transaction and client interaction.
                    </p>
                  </div>
                  <div className="row mt-4">
                    <div className="col-md-6">
                      <ul className="icon_list unordered_list_block">
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Remote staffing for all real estate roles</span>
                        </li>
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Quick onboarding and flexible contracts</span>
                        </li>
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Support for agencies, brokers, and property managers</span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="icon_list unordered_list_block">
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Transparent reporting and analytics</span>
                        </li>
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Data security and confidentiality</span>
                        </li>
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Continuous skills development</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CompanyInfo/>
            <div className="row mt-5">
              <div className="col-lg-12">
                <div className="heading_block mb-5">
                  <h2 className="heading_text">Why Choose <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> for Real Estate?</h2>
                </div>
              </div>
            </div>
            <div className="row g-4 mb-5">
              <div className="col-lg-4 d-flex">
                <div className="iconbox_block" style={{
                  border: '1px solid var(--bs-border-color)', 
                  borderRadius: 'var(--bs-border-radius)',
                  height: '100%',
                  padding: '40px 30px',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(135, 206, 235, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '25px'
                  }}>
                    <i className="fas fa-home" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                  </div>
                  <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Industry-Specific Talent</h3>
                  <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Access experienced real estate assistants, coordinators, and marketers ready to support your business.</p>
                </div>
              </div>
              <div className="col-lg-4 d-flex">
                <div className="iconbox_block" style={{
                  border: '1px solid var(--bs-border-color)', 
                  borderRadius: 'var(--bs-border-radius)',
                  height: '100%',
                  padding: '40px 30px',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(135, 206, 235, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '25px'
                  }}>
                    <i className="fas fa-handshake" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                  </div>
                  <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Seamless Collaboration</h3>
                  <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Work with professionals who understand real estate workflows and client expectations.</p>
                </div>
              </div>
              <div className="col-lg-4 d-flex">
                <div className="iconbox_block" style={{
                  border: '1px solid var(--bs-border-color)', 
                  borderRadius: 'var(--bs-border-radius)',
                  height: '100%',
                  padding: '40px 30px',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(135, 206, 235, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '25px'
                  }}>
                    <i className="fas fa-chart-bar" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                  </div>
                  <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Scalable Support</h3>
                  <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Easily scale your team up or down to match market cycles and business needs.</p>
                </div>
              </div>
            </div>
          </div>
       </section>
      </div>
    );
  };

export default RealEstateIndustry;